import { render, staticRenderFns } from "./TablePaginationButtons.vue?vue&type=template&id=c8c9edd8&"
import script from "./TablePaginationButtons.vue?vue&type=script&lang=js&"
export * from "./TablePaginationButtons.vue?vue&type=script&lang=js&"
import style0 from "./TablePaginationButtons.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports